import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { DashboardView } from 'ops/common/models/dashboard-view';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DashboardViewApiService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getDashboard(): Observable<DashboardView> {
        return this.http.get<DashboardView>(`${this.domain}/api/ops/dashboard`);
    }

    public update(dashboard: DashboardView): Observable<DashboardView> {
        return this.http.put<DashboardView>(
            `${this.domain}/api/ops/dashboard/${dashboard.id ?? ''}`,
            dashboard,
        );
    }
}
